import { OpcionSpEnum } from './OpcionSpEnum';

export class Base {
    pCodRetorno: string;
    pMensaje: string;
    pOpcion: OpcionSpEnum;
    pTotalItems:number;
    pcodRetorno:string;
    pmensaje:string;
}
